export const DISABLE_CHECKSUM_TENANTURL = ['demo', 'pen-test-1', 'pen-test-2', 'otn-demo'];

export const ENABLE_CHECKSUM_ENV = ['production'];
